import React from "react";
import { motion } from "framer-motion";
import { SITE } from "@/lib/site";

const beliefs = [
  { num: "01", title: "Restore", desc: "Movement quality, mobility, and pain-free range first." },
  { num: "02", title: "Rebuild", desc: "Joint-friendly strength with intentional progression." },
  { num: "03", title: "Refine", desc: "Body composition, posture, and performance compound over time." },
];

export const AboutBrand = () => {
  return (
    <section
      data-testid="about-brand-section"
      className="relative py-20 sm:py-28 lg:py-36 border-t border-white/5 overflow-hidden"
    >
      <div className="aurora" style={{ background: "#00E5FF", width: 500, height: 500, top: -100, left: -150, opacity: 0.18 }}></div>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative z-10">
        <div className="grid lg:grid-cols-12 gap-14">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-6"
          >
            <div className="text-xs uppercase tracking-[0.3em] text-[#00E5FF] mb-4">About Corrective Motion</div>
            <h2 className="font-display text-4xl lg:text-5xl xl:text-6xl font-extrabold leading-[1.05] tracking-[-0.02em] text-white">
              A system for the body <span className="text-gradient-blue">you'll live in for life.</span>
            </h2>
            <p className="mt-6 text-zinc-300/90 text-lg leading-relaxed">
              Corrective Motion is a clinical, evidence-based training system focused on
              improving movement quality, reducing pain, and correcting muscular imbalances.
              This is the foundation for sustainable strength, fat loss, and posture transformation.
            </p>
            <p className="mt-4 text-zinc-400 leading-relaxed">
              It's training that respects the body. Built for executives, professionals,
              athletes, and anyone tired of programs that look good on Instagram but break
              down joints in real life.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="lg:col-span-6"
          >
            <div className="relative rounded-3xl overflow-hidden ring-1 ring-white/10">
              <img
                src={SITE.images.method}
                alt="Corrective exercise training environment in Dubai"
                loading="lazy"
                decoding="async"
                className="w-full h-[420px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-7 grid grid-cols-3 gap-4">
                {beliefs.map((b) => (
                  <div key={b.num} className="border-t border-white/15 pt-4">
                    <div className="text-[10px] font-mono text-[#00E5FF]">{b.num}</div>
                    <div className="font-display text-white font-bold text-base mt-1">{b.title}</div>
                    <div className="text-[11px] text-zinc-300 mt-1 leading-snug">{b.desc}</div>
                  </div>
                ))}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutBrand;
